export default __webpack_public_path__ + "bc30d57d61d58ad0bba4440c21791ddc.svg";